// Defensive string helpers used in UI rendering to avoid runtime errors
export function safeCap(input: unknown): string {
  if (typeof input === 'string') {
    if (input.length === 0) return '';
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  if (input == null) return '';
  const s = String(input);
  if (s.length === 0) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function safeInitial(input: unknown): string {
  return safeCap(input).charAt(0) || '';
}
